import request from '@/axios'

export function getPaddleCustomerActiveSubscriptionsApi (payload) {
  return request({
    url:`paddle/get_paddle_customer_active_subscriptions`,
    method:'POST',
    data: payload
  })
}

export function paddleProrationUpdatePlanApi (paddle_payload, subscription_id) {
  return request({
    url:`paddle/paddle_proration_update_plan/`+subscription_id,
    method:'POST',
    data: paddle_payload
  })
}

export function addNewItemsSubscriptionPreviewApi (paddle_payload, subscription_id) {
  return request({
    url:`paddle/add_new_items_subscription_preview/`+subscription_id,
    method:'POST',
    data: paddle_payload
  })
}

export function addNewItemsSubscriptionUpdateApi (paddle_payload, subscription_id) {
  return request({
    url:`paddle/add_new_items_subscription_update/`+subscription_id,
    method:'POST',
    data: paddle_payload
  })
}

export function removeItemsSubscriptionUpdateApi (paddle_payload, subscription_id) {
  return request({
    url:`paddle/remove_items_subscription_update/`+subscription_id,
    method:'POST',
    data: paddle_payload
  })
}

export function getActivePaddleProductsApi () {
  return request({
    url:`paddle/get_active_paddle_products`,
    method:'GET'
  })
}

export function calculatePaddleCustomerCustomDataApi (payload) {
  return request({
    url:`paddle/calculate_paddle_customer_customdata`,
    method:'POST',
    data: payload
  })
}

export function getPaddleCustomerIdApi (payload) {
  return request({
    url:`paddle/get_paddle_customer_id`,
    method:'POST',
    data: payload
  })
}

export function getOneTimeAddonsImmediatelySubscriptionApi (payload) {
  return request({
    url:`paddle/get_one_time_addons_immediately_subscription`,
    method:'POST',
    data: payload
  })
}

export function getPaddlePriceDetailApi (payload) {
  return request({
    url:`paddle/get_paddle_price_detail`,
    method:'POST',
    data: payload
  })
}

export function registerOrganizationApi (payload) {
  return request({
    url:`school_registration`,
    method:'POST',
    data: payload
  })
}

export function createPaddleCustomerAPI (payload) {
  return request({
    url:`paddle/create_paddle_customer`,
    method:'POST',
    data: payload
  })
}

export function createPaddleCustomerAddressAPI (payload) {
  return request({
    url:`paddle/create_paddle_customer_address`,
    method:'POST',
    data: payload
  })
}

export function createPaddleTransactionAPI (payload) {
  return request({
    url:`paddle/create_paddle_transaction`,
    method:'POST',
    data: payload
  })
}
